import { render, staticRenderFns } from "./DeleteAGMModal.vue?vue&type=template&id=56fa55be"
import script from "./DeleteAGMModal.vue?vue&type=script&lang=js"
export * from "./DeleteAGMModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteAGMModal.vue?vue&type=style&index=0&id=56fa55be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports